import { render } from "./DocumentClassFieldGoupsSubView.vue?vue&type=template&id=608e8062&scoped=true&ts=true"
import script from "./DocumentClassFieldGoupsSubView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassFieldGoupsSubView.vue?vue&type=script&lang=ts"

import "./DocumentClassFieldGoupsSubView.vue?vue&type=style&index=0&id=608e8062&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608e8062"]])

export default __exports__